export enum AccessRoleType {
    SA = 1,
    AccountManager = 2,
    CompanyAdmin = 3,
    CompanyUser = 4,
    CompanyPrimaryAdmin = 5,
}

export enum SupplyChainAccessRoleType {
    Client = 1,
    Vendor = 2,
}
